import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62629fee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-10 flex justify-center" }
const _hoisted_2 = { class: "flex items-stretch" }
const _hoisted_3 = { class: "m-2 flex flex-col" }
const _hoisted_4 = {
  key: 0,
  class: "locked flex-col justify-center items-center align-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-10" }, "This vault is locked!", -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NFTGrid = _resolveComponent("NFTGrid")!
  const _component_ArrowButton = _resolveComponent("ArrowButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (
        (_ctx.toWalletNFTs && _ctx.toWalletNFTs.length) ||
        (_ctx.toVaultNFTs && _ctx.toVaultNFTs.length)
      )
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "nes-btn is-primary mr-5",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.moveNFTsOnChain && _ctx.moveNFTsOnChain(...args)))
          }, " Move Gems! "))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NFTGrid, {
        title: "Your wallet",
        class: "flex-1",
        nfts: _ctx.desiredWalletNFTs,
        onSelected: _ctx.handleWalletSelected
      }, null, 8, ["nfts", "onSelected"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ArrowButton, {
          disabled: _ctx.vaultLocked,
          class: "my-2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moveNFTsFE(false)))
        }, null, 8, ["disabled"]),
        _createVNode(_component_ArrowButton, {
          disabled: _ctx.vaultLocked,
          class: "my-2",
          left: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveNFTsFE(true)))
        }, null, 8, ["disabled"])
      ]),
      (_ctx.bank && _ctx.vault)
        ? (_openBlock(), _createBlock(_component_NFTGrid, {
            key: 0,
            title: "Staking",
            class: "flex-1",
            nfts: _ctx.desiredVaultNFTs,
            onSelected: _ctx.handleVaultSelected
          }, {
            default: _withCtx(() => [
              (_ctx.vaultLocked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["nfts", "onSelected"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}